import { useLocation } from 'react-router';
import { useEffect } from 'react';
import { Mixpanel } from 'src/tracking/mixpanel/Mixpanel';
import { MixpanelEvents } from 'src/tracking/mixpanel/MixpanelEvents';

export const PageViewTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const pathname = location.pathname;
    const title = document.title;
    const raw = sessionStorage.getItem('app-sidebar-collapsed');
    const siestaChatOpen = raw === null ? true : !JSON.parse(raw);

    // @ts-expect-error Exception where I need a string
    Mixpanel.track(`${MixpanelEvents.PAGE_VIEWED} - ${pathname}`, {
      page: title,
      path: pathname,
      timestamp: new Date().toISOString(),
      siestaChatOpen,
    });
  }, [location]);

  return null;
};
